export const proxyUrl = 'https://gentle-caverns-95036.herokuapp.com/'

export const targetUrl = 'https://5tahdbrr12.execute-api.us-east-1.amazonaws.com/beta'



// WEBPACK FOOTER //
// ./src/Variables/Variables.js